import { useCallback, useState } from 'react'
import { DefaultValues, FieldValues, UseFormReturn } from 'react-hook-form'

import { useSavedFilters } from './useSaveFilters'
import { AllFiltersArea } from '../filter.types'
import { Any } from '@api/orvalFetcher'

interface UseSaveFilterModalParams<T extends FieldValues> {
  form: UseFormReturn<T>
  filtersArea: AllFiltersArea
  initialValues: DefaultValues<T>
}

export function useSaveFilterModal<T extends FieldValues>({
  form,
  filtersArea,
  initialValues,
}: UseSaveFilterModalParams<T>) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [filterName, setFilterName] = useState('')

  const { handleSaveFilter, handleDeleteFilter, savedFilters, handleSavedFilterChange } = useSavedFilters({
    form,
    filtersArea: filtersArea as Any, // TODO: change after backend updates
    filterName,
    setFilterName,
    setIsModalOpen,
    initialValues,
  })

  const openModal = useCallback(() => setIsModalOpen(true), [])

  const cancelModal = useCallback(() => {
    setIsModalOpen(false)
    setFilterName('')
  }, [])

  return {
    isModalOpen,
    filterName,
    setFilterName,
    openModal,
    cancelModal,
    handleSaveFilter,
    handleDeleteFilter,
    savedFilters,
    handleSavedFilterChange,
  }
}
